import AssessmentIntroductionDisplay from './AssessmentIntroductionDisplay';

export default AssessmentIntroductionDisplay;
